import { useEffect, useState } from "react";
import { FilterValues } from "@/components/ui/FilterBar/types";
import { fetchKanbanCompras, KanbanComprasData } from "@/services/suprimentos";

interface UseSuprimentosReturn {
  data:    KanbanComprasData | null;
  loading: boolean;
  error:   string | null;
}

export function useSuprimentos(filters: FilterValues): UseSuprimentosReturn {
  const [data,    setData]    = useState<KanbanComprasData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState<string | null>(null);

  const { startDate, endDate, costCenter } = filters;

  // Defesa contra costCenter não-array (HMR stale state ou estado persitido com formato antigo)
  const costCenterArr = Array.isArray(costCenter) ? costCenter : [];
  const costCenterKey = costCenterArr.join(",");
  const fetchKey = `${startDate}|${endDate}|${costCenterKey}`;

  useEffect(() => {
    setLoading(true);
    setError(null);

    fetchKanbanCompras({
      ...filters,
      costCenter: costCenterArr,
    })
      .then((result) => {
        setData(result);
        setLoading(false);
      })
      .catch((err: unknown) => {
        const msg =
          (err as { response?: { data?: { error?: string } } })?.response?.data?.error ??
          (err instanceof Error ? err.message : "Erro ao carregar dados de suprimentos.");
        setError(msg);
        setLoading(false);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchKey]);

  return { data, loading, error };
}
